import styled from "@emotion/styled";
import { Box as RebassBox } from "rebass";

const Box = styled(RebassBox)``;

export default Box;
